<!-- Global Loader -->
<app-global-loader />

<app-header />
<div class="container">
<router-outlet />
<app-footer />
</div>
